import React from 'react';
import { useTranslation, Translation } from 'react-i18next';
import PropTypes from 'prop-types';
import set from 'lodash/set';
import { reduxForm, Field } from 'redux-form';
import {
  FormUi,
  Header,
  Dimmer,
  Loader,
  Segment,
  Flex,
  Button,
  Grid,
  G,
} from 'nallian-shared-ui/lib/components';
import { InputFieldValueComponent } from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { isValidEmail } from 'nallian-shared-ui/lib/lib/validate';

const validate = values => {
  const errors = {};

  if (values?.fromEmail && !isValidEmail(values.fromEmail)) {
    set(errors, 'fromEmail', <Translation>{t => t('invalidEmailErr')}</Translation>);
  }
  if (values?.replyToEmail && !isValidEmail(values.replyToEmail)) {
    set(errors, 'replyToEmail', <Translation>{t => t('invalidEmailErr')}</Translation>);
  }
  if (values?.contactEmail && !isValidEmail(values.contactEmail)) {
    set(errors, 'contactEmail', <Translation>{t => t('invalidEmailErr')}</Translation>);
  }

  return errors;
};

const NotificationSettingsForm = ({ handleSubmit, onSubmitForm, loading, submitting }) => {
  const { t } = useTranslation();

  return (
    <FormUi onSubmit={handleSubmit(onSubmitForm)}>
      <Segment basic>
        <Dimmer active={loading} inverted>
          <Loader />
        </Dimmer>
        {!loading && (
          <>
            <Header style={{ marginTop: '0' }} dividing>
              {t('notificationSettings')}
            </Header>
            <Grid stackable>
              <G.Row columns={2}>
                <G.Col>
                  <Field
                    autoFocus
                    type="text"
                    label={t('fromEmail')}
                    name="fromEmail"
                    valueComponent={InputFieldValueComponent}
                    disabled={loading || submitting}
                  />
                </G.Col>
                <G.Col>
                  <Field
                    label={t('fromName')}
                    name="fromName"
                    valueComponent={InputFieldValueComponent}
                    disabled={loading || submitting}
                  />
                </G.Col>
              </G.Row>
              <G.Row columns={2}>
                <G.Col>
                  <Field
                    type="text"
                    label={t('replyToEmail')}
                    name="replyToEmail"
                    valueComponent={InputFieldValueComponent}
                    disabled={loading || submitting}
                  />
                </G.Col>
                <G.Col>
                  <Field
                    label={t('replyToName')}
                    name="replyToName"
                    valueComponent={InputFieldValueComponent}
                    disabled={loading || submitting}
                  />
                </G.Col>
              </G.Row>
              <G.Row columns={2}>
                <G.Col>
                  <Field
                    label={t('contactEmail')}
                    name="contactEmail"
                    valueComponent={InputFieldValueComponent}
                    disabled={loading || submitting}
                  />
                </G.Col>
                <G.Col>
                  <Field
                    type="text"
                    label={t('emailSubjectPrefix')}
                    name="emailSubjectPrefix"
                    valueComponent={InputFieldValueComponent}
                    disabled={loading || submitting}
                  />
                </G.Col>
              </G.Row>
            </Grid>
            <Flex justifyContent="flex-end" margin="2rem 0 0">
              <Button
                btnprimary
                onClick={handleSubmit(onSubmitForm)}
                disabled={submitting}
                loading={submitting}
                icon="save"
                content={t('save')}
              />
            </Flex>
          </>
        )}
      </Segment>
    </FormUi>
  );
};

NotificationSettingsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

NotificationSettingsForm.defaultProps = { initialValues: undefined };

export default reduxForm({
  validate,
  form: 'notificationSettings',
  enableReinitialize: true,
})(NotificationSettingsForm);
